function formatDate(isoDateString) {
  const date = new Date(isoDateString);

  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Month is zero-based, so add 1
  const day = date.getDate().toString().padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export default formatDate;

export const CustomformatDate = (dateString) => {
  const date = new Date(dateString);

  // Format options for day, month, and weekday
  const options = { day: "numeric", month: "short", weekday: "short" };

  // Format the date using Intl.DateTimeFormat
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);

  return formattedDate;
};


